import React, { useState } from 'react';
import Image from './Image';
import Button from './Button';
import { Link } from 'react-router-dom';

interface NavItemProps {
	children: React.ReactNode;
	to: string;
	className?: string;
}

const NavItem: React.FC<NavItemProps> = ({ children, to, className }) => (
	<Link to={to} className={`self-stretch my-auto ${className}`}>{children}</Link>
);

const Nav2 = () => {

	const [isOpen, setIsOpen] = useState(false);

	const toggleMenu = () => {
		setIsOpen(!isOpen);
	};

	return (
		<nav className="p-5 fixed w-full">
			<div className="backdrop-blur-xl flex gap-5 justify-between px-7 py-1 text-white bg-zinc-400 bg-opacity-30 rounded-[65px] max-lg:flex-wrap max-md:max-w-full">
				<Link to="/" className="flex gap-5 duration-500 justify-between px-3 py-1 w-[60px] lg:w-[300px] font-bold text-5xl leading-6">
					<Image src="./assets/billbaordBlue.svg" alt="Billboard logo" className="min-w-[60px]" />
					<div className="my-auto max-lg:hidden text-5xl">Billboard</div>
				</Link>

				<div className={`flex gap-5 justify-between items-center px-3 py-1 text-xl leading-6 `}>
					<div className="flex items-center sm:hidden">
						<button onClick={toggleMenu} className="text-white focus:outline-none">
							<svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								{isOpen ? (
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
								) : (
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
								)}
							</svg>
						</button>
					</div>
					<div className={`flex gap-5 leading-6 ${isOpen ? 'flex' : 'hidden'} sm:flex`}>
						<NavItem className="hover:opacity-50 duration-500" to={"/advertiser"}>Advertiser</NavItem>
						<NavItem className="hover:opacity-50 duration-500" to={"/publisher"}>Publisher</NavItem>
						{/* <NavItem to={"/marketplace"} className="flex-auto">Marketplace</NavItem> */}
						<Button to={"/app/"} background='linear-gradient(62deg, #6100FF 0%, #00FFD1 100%)'>Open dAPP</Button>
					</div>
				</div>
			</div>
		</nav>
	)
}

export default Nav2